import React from "react";
import { ListGroup, ListGroupItem } from "reactstrap";

const ItemList = ({ children }) => (
  <ListGroup className={"box"}>
    {children
      .filter((x) => x)
      .map((Item) => (
        <ListGroupItem>{Item}</ListGroupItem>
      ))}
  </ListGroup>
);
export default ItemList;
